import React from 'react';

import { saveAs } from 'file-saver';

import { Button, Flex, Card, Modal } from 'antd';
import { NotificationInstance } from 'antd/es/notification/interface';
import { DownloadOutlined } from '@ant-design/icons';

import IBaseComponentProps from '@components/base-component-props';
import { dataURItoBlob } from '@extensions/utils';
import { exception } from '@extensions/notification';
import { getDateTimeLocal } from '@extensions/utils';
import { useAppDispatch } from '@store/hooks';

import { userLoaded } from '@store/actions';

import { INotification } from '@entities/notification';

import { NotificationType } from '@enums/notification-type';

interface IPushPersonalModalProps extends IBaseComponentProps {
    items: Array<INotification>;
    api: NotificationInstance;
    onClose: () => void;
}

const PushPersonalModal = (props: IPushPersonalModalProps) => {
    const { items, api, onClose, serverFetch } = props;

    const d = useAppDispatch();

    const onSetReadAll = () => {
        serverFetch(`notifications/readall`, { method: 'POST' })
            .then(() => {
                onClose();
            })
            .catch((ex: any) => {
                exception(api, 'Ошибка изменения статуса сообщения', ex, () => d(userLoaded(undefined)));
            });
    };

    const onDownload = async (file: any) => {
        serverFetch(`notifications/attachment/${file?.uid}/download`, { method: 'GET' })
            .then((data: any) => {
                const fileBody = `data:${data.contentType};base64,${data.fileContents}`;
                saveAs(dataURItoBlob(fileBody), data.fileDownloadName);
            })
            .catch((ex: any) => {
                exception(api, 'Ошибка загрузки документа', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <Modal
            title={<div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'start', fontSize: 18 }}>Новое уведомление</div>}
            width={800}
            open={true}
            okButtonProps={{
                style: { display: 'none' },
            }}
            cancelButtonProps={{
                style: { display: 'none' },
            }}
            closable={false}
            styles={{
                header: {
                    borderBottom: `1px solid #cdcdcd`,
                    borderRadius: 0,
                    paddingBottom: 10,
                },
                body: { overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' },
            }}
        >
            <div style={{ marginRight: 10 }}>
                {items.map((n) => {
                    return (
                        <Card
                            key={n.id}
                            title={
                                <Flex align='start' justify='space-between'>
                                    <div style={{ whiteSpace: 'break-spaces' }}>{n.subject}</div>
                                    <div style={{ color: '#828282', fontWeight: 'normal', fontSize: 14 }}>
                                        {getDateTimeLocal(n.createdOn)}
                                    </div>
                                </Flex>
                            }
                            style={{ marginTop: 20, borderColor: n.type == NotificationType.User ? '#108EE9' : '' }}
                            styles={{
                                header: {
                                    border: 'none',
                                },
                                body: { paddingTop: 0, fontSize: 14, whiteSpace: 'pre-wrap' },
                            }}
                        >
                            {n.body}

                            {n.files && n.files.length > 0 && (
                                <Flex gap='small' orientation='vertical' align='start' style={{ marginTop: 10 }}>
                                    {n.files.map((d) => (
                                        <Button
                                            style={{ paddingLeft: 0 }}
                                            icon={<DownloadOutlined />}
                                            variant='link'
                                            color='blue'
                                            onClick={() => onDownload(d)}
                                        >
                                            {d.name}
                                        </Button>
                                    ))}
                                </Flex>
                            )}
                        </Card>
                    );
                })}
                <Flex justify='flex-end' style={{ marginTop: 20 }}>
                    <Button onClick={() => onSetReadAll()} size='large' type='default'>
                        Закрыть
                    </Button>
                </Flex>
            </div>
        </Modal>
    );
};

export default PushPersonalModal;
